var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('div',{ref:"card"}),_c('p',{attrs:{"id":"card-error","role":"alert"}}),_c('v-btn',{attrs:{"loading":_vm.paymentStarted,"disabled":_vm.disablePayment || _vm.disablePaymentCommon || _vm.isDisabled},on:{"click":_vm.proceedPayment}},[_vm._v("CONFIRM PAYMENT")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }